import config from '@/config/index.js';

// http://showdoc.nevint.com/index.php?s=/lifestyle&page_id=19349
const decode = {
    url: `/api/2/in/lifestyle/account/user/decode`,
    method: 'get'
};
// vom
const vomDecode = {
    url: `/beyonder/api/v1/wx/params/decode`,
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};
// vom
const vomEncode = {
    url: `/beyonder/api/v1/wx/params/encode`,
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

export default {
    decode,
    vomDecode,
    vomEncode
};



// WEBPACK FOOTER //
// ./src/service/common/code.js